import axios from "axios";
import { useQuery } from "./useQuery";

export function isEmailReportCTA() {
    return useQuery().get("type") === "email_report";
}

export function getEventName() {
    return useQuery().get("event")
}

export function sendPlausibleEvent(eventName) {
    const domain = window.location.hostname.replace(/^www\./, '');
    const user_account_uuid = useQuery().get('parent_user_account_uuid')
    const subscription_status = useQuery().get('subscription_status')

    axios.post("https://plausible.io/api/event", {
        name: eventName,
        url: window.location.href,
        domain: domain,
        props: {
            user_account_uuid: user_account_uuid,
            subscription_status: subscription_status
        }
    })
    .catch((error) => {
        console.error("Failed to send Plausible event:", error);
    });
}